import { render } from "./IssueDiscountList.vue?vue&type=template&id=51da362d&ts=true"
import script from "./IssueDiscountList.vue?vue&type=script&lang=ts"
export * from "./IssueDiscountList.vue?vue&type=script&lang=ts"

import "./IssueDiscountList.vue?vue&type=style&index=0&id=51da362d&lang=scss"

import exportComponent from "/home/jenkins/agent/workspace/git_node_build_images_push_anjinq_test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__